module.exports = __webpack_public_path__ + "img/bebida.1e095741.png";